module.exports = __webpack_public_path__ + "static/images/gift-lists.a6569d3.png";